import axios from 'axios'

export default {
  async delete (id) {
    return await axios.post('/api/spa/v1/image/delete/' + id)
  }

}
